export class Drivers {
  id = '';
  title = '';
  firstName = '';
  lastName = '';
  dob = '';
}
